module.exports = __webpack_public_path__ + "static/media/bc_terminology.283c84e1.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd552/bc_terminology.JPG
// module id = 59
// module chunks = 0